import * as definitions from "~/definitions";
import * as api from "./youtube.thumbnail.downloader.definitions.api";
import * as app from "./youtube.thumbnail.downloader.definitions.app";

export namespace error {
  export interface schema {
    exists: boolean;
    message: string;
    code: api.definitions.http.error.code;
  }

  export namespace create {
    export function fn() {
      return reactive<error.schema>({
        exists: false,
        message: "",
        code: api.definitions.http.error.code._0
      });
    }
  }

  export namespace reset {
    export function fn(error: error.schema) {
      error.message = "";
      error.exists = false;
      error.code = api.definitions.http.error.code._0;
    }
  }

  export namespace x500 {
    export function fn() {
      throw new app.error("Something went wrong", api.definitions.http.error.code._500);
    }
  }
}

export namespace seo {
  const keywords = [
    ...definitions.seo.get.global.keywords,
    "youtube",
    "youtube downloader",
    "youtube thumbnail downloader",
    "downloader",
    "thumbnail"
  ];

  export namespace og {
    export namespace image {
      export const index = "/og/app_youtube_thumbnail_downloader.png";
    }
  }

  export namespace set {
    export namespace index {
      export function fn() {
        const data = {
          title: "YouTube Thumbnail Downloader - Incigma",
          description:
            "Download high-res YouTube thumbnails instantly. Paste a URL to save original or max-resolution images. Free, fast, privacy-first.",
          keywords: keywords,
          author: "Incigma.com",
          image: seo.og.image.index
        };

        useNuxtApp().$seo.simple(data);
      }
    }

    export namespace show {
      type error = api.definitions.http.error.scheme;
      type response = app.definitions.controller.process.schema;

      export function fn(params: { response?: response["body"]; error?: error }) {
        useNuxtApp().$seo.simple;
        var data = {} as Parameters<ReturnType<typeof useNuxtApp>["$seo"]["simple"]>[0];

        if (params.error) {
          data = Object.assign(data, {
            title: `${params.error.code} | ${params.error.message} - YouTube Thumbnail Downloader`,
            description:
              "Download high-res YouTube thumbnails instantly. Paste a URL to save original or max-resolution images. Free, fast, privacy-first.",
            keywords: keywords,
            author: "Incigma.com",
            image: seo.og.image.index
          });
        } else if (params.response) {
          data = Object.assign(data, {
            title: `${params.response.info.video.title} - YouTube Thumbnail Downloader`,
            description:
              "Download high-res YouTube thumbnails instantly. Paste a URL to save original or max-resolution images. Free, fast, privacy-first.",
            keywords: keywords,
            author: params.response.info.channel.name!,
            image: app.url(params.response.latest.url!)
          });
        }

        useNuxtApp().$seo.simple(data);
      }
    }
  }
}
